/*
 * summary: this module is to handle the promo flyer functionality
 * we need to set the data-promo-flyer-url to the promo that contain a flyer value
 */
(function (global) {
  const flyerButtons = document.querySelectorAll('[data-promo-flyer-url]');

  function openFlyer(event) {
    const url = event.target.dataset.promoFlyerUrl;
    const left = (global.screen.width - 840) / 2;
    const top = (global.screen.height - 600) / 2;
    const dimentionsSetting = `width=840,height=600,top=${top},left=${left},menubar=yes,status=no,
      location=no,toolbar=no,scrollbars=yes`;

    global.open(url, '_blank', dimentionsSetting);
  }

  flyerButtons.forEach((flyerUrl) => {
    flyerUrl.addEventListener('click', openFlyer);
  });
})(window);